function initProjectOrganizationSelect() {
  var jQuery = window.jQuery;
  if (!jQuery || typeof jQuery.fn.select2 === 'undefined') return;
  const organizationId = document.getElementById('project_organization_id');
  if (!organizationId || organizationId.type === 'hidden') return;
  if (jQuery('#project_organization_id').hasClass('select2-hidden-accessible')) return;

  jQuery('#project_organization_id').select2({
    placeholder: 'Select Client',
    allowClear: true,
    width: '100%'
  });
}

document.addEventListener('turbolinks:load', initProjectOrganizationSelect);

document.addEventListener('turbolinks:before-cache', function() {
  var jQuery = window.jQuery;
  if (!jQuery || typeof jQuery.fn.select2 === 'undefined') return;
  if (!document.getElementById('project_organization_id')) return;
  jQuery('#project_organization_id').select2('destroy');
});
